import { ProcedureUnitTypeRulesConfig } from '../models/unit-type-rules-config';
import { rulesForBridgeFixedRestorative } from './unit-type-rules/bridge-fixed-restorative';
import { rulesForBridgeFixedRestorativeGlidewellIo } from './unit-type-rules/bridge-fixed-restorative-glidewell-io';

export const procedureBridgeUnitTypeMaterialRules: ProcedureUnitTypeRulesConfig = {
	ProcedureRules: [rulesForBridgeFixedRestorativeGlidewellIo, rulesForBridgeFixedRestorative]
};
